import { useCallback, useEffect, useMemo, useState } from 'react'
import { ProjectOrCategoryColumnModel } from '../../models'
import { IProjectOrCategory, ProjectOrCategorySelect, ProjectOrCategoryType } from 'features/Project'

type Props = {
	column: ProjectOrCategoryColumnModel
	value: string
	onChange(value: string): void
	onBlur(): void
	loading: boolean
}

export const ProjectOrCategoryEditableCell = ({ column, value, onChange, onBlur, loading }: Props) => {
	const [projectOrCategory, setProjectOrCategory] = useState<ProjectOrCategoryType | undefined>();

	const initialProjectOrCategory = useMemo<ProjectOrCategoryType | undefined>(
		() => {
			if (!value) {
				return;
			}

			// projectOrCategoryId is not unique, isProjectConnected must be used somehow
			// value is defined in tableColumns as projectOrCategoryId_isProjectConnected
			// if you change this value, change parsing inside TimesheetsTable cellEditedCallback
			const [projectOrCategoryIdStr, isProjectConnectedStr] = value.split('_');
			const id = parseInt(projectOrCategoryIdStr);
			return {
				projectOrCategoryId: id,
				isProjectConnected: isProjectConnectedStr === 'true'
			}
		},
		[value]
	)

	useEffect(
		() => {
			if (initialProjectOrCategory) {
				setProjectOrCategory(initialProjectOrCategory);
			}
		},
		[initialProjectOrCategory]
	)

	const handleChangeCallback = useCallback(
		(newValue: ProjectOrCategoryType | undefined) => {
			setProjectOrCategory(newValue);

			if (newValue) {
				onChange(`${newValue.projectOrCategoryId}_${newValue.isProjectConnected}`);
			}
		},
		[onChange]
	)

	const filterEditableProjectOrCategory = useCallback(
		(items: IProjectOrCategory[]) => items.filter(item => item.isProjectConnected || !item.isReadOnly),
		[]
	)

	return (
		<ProjectOrCategorySelect
			value={projectOrCategory}
			onChange={handleChangeCallback}
			onBlur={onBlur}
			{...column.options}
			initialProjectOrCategory={projectOrCategory}
			additionalFilter={filterEditableProjectOrCategory}
			loading={loading}
			withLabel={false}
			size='small'
		/>
	)
}
